import { useEffect, useState } from 'react'

import DeviceDetector from 'device-detector-js'

import { Hotkey } from '@tribeplatform/react-ui-kit/Hotkey'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../i18n/index.js'
import { COMMAND_BAR_HOTKEYS } from '../CommandBar.constants.js'
import { CommandBarMode } from '../CommandBar.types.js'
import { useCommandBar } from '../CommandBarContext.js'

const keys = {
  enter: 'enter',
  esc: 'esc',
}

export const HotkeysGuide = () => {
  const { open, searchOptions } = useCommandBar()
  const [isDesktopDevice, setIsDesktopDevice] = useState(false)
  const deviceDetector = new DeviceDetector()

  useEffect(() => {
    const device = deviceDetector.parse(navigator.userAgent)

    if (device.device?.type === 'desktop') {
      setIsDesktopDevice(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isDesktopDevice) {
    return null
  }

  return (
    <footer className="flex px-4 lg:px-5 gap-4 py-2 border-t bg-surface-disabled text-xs cursor-default">
      <div className="flex gap-1 items-center">
        <div className="w-6 aspect-square flex items-center justify-center rounded-md bg-surface border">
          <SvgIcon name="arrow-up" />
        </div>
        <div className="w-6 aspect-square flex items-center justify-center rounded-md bg-surface border">
          <SvgIcon name="arrow-down" />
        </div>
        <span>
          <T id="CommandBar.Hotkeys.Navigate" defaultMessage="to navigate" />
        </span>
      </div>

      <div className="flex gap-1 items-center">
        <Hotkey className="h-6 aspect-square flex items-center justify-center rounded-md bg-surface border">
          {keys.enter}
        </Hotkey>
        <span>
          <T id="CommandBar.Hotkeys.Select" defaultMessage="to select" />
        </span>
      </div>

      {searchOptions.mode === CommandBarMode.SEARCH && (
        <div
          className="flex gap-1 items-center cursor-pointer hover:opacity-85"
          onClick={() =>
            open({ searchOptions: { mode: CommandBarMode.COMMANDS } })
          }
        >
          <span className="h-6 px-2 flex items-center justify-center rounded-md bg-surface border [&>kbd]:text-xs">
            {COMMAND_BAR_HOTKEYS.COMMANDS.label}
          </span>
          <span>
            <T
              id="CommandBar.Hotkeys.CommandsLists"
              defaultMessage="to access commands list"
            />
          </span>
        </div>
      )}

      {searchOptions.mode === CommandBarMode.COMMANDS && (
        <div
          className="flex gap-1 items-center cursor-pointer hover:opacity-85"
          onClick={() =>
            open({
              searchOptions: { mode: CommandBarMode.SEARCH },
            })
          }
        >
          <span className="h-6 px-2 flex items-center justify-center rounded-md bg-surface border [&>kbd]:text-xs">
            {COMMAND_BAR_HOTKEYS.SEARCH.label}
          </span>
          <span>
            <T id="CommandBar.Hotkeys.Search" defaultMessage="to search" />
          </span>
        </div>
      )}

      <div className="flex gap-1 items-center">
        <Hotkey className="h-6 px-2 flex items-center justify-center rounded-md bg-surface border [&>kbd]:text-xs">
          {keys.esc}
        </Hotkey>
        <span>
          <T id="CommandBar.Hotkeys.Close" defaultMessage="to close" />
        </span>
      </div>
    </footer>
  )
}
